import { Extension } from '@tiptap/core';

export interface TextColorOptions {
   types: string[];
   colors: string[];
   defaultColor: null | string;
}

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      textColor: {
         setTextColor: (color: string) => ReturnType;
         unSetTextColor: () => ReturnType;
      };
   }
}

export const CustomTextColor = Extension.create<TextColorOptions>({
   name: 'customTextColor',
   addOptions() {
      return {
         types: ['tableCell', 'tableHeader'],
         colors: [
            '#FFFFFF',
            '#CCCCCC',
            '#9E9E9E',
            '#858585',
            '#000000',
            '#DD4A36',
            '#F4A967',
            '#FFD466',
            '#89BC77',
            '#6293E4',
            '#F9A0F0',
         ],
         defaultColor: null,
      };
   },
   addGlobalAttributes() {
      return [
         {
            types: this.options.types,
            attributes: {
               textColor: {
                  default: this.options.defaultColor,
                  parseHTML: element => element.style.color || this.options.defaultColor,
                  renderHTML: attributes => {
                     if (attributes.textColor === this.options.defaultColor) {
                        return {};
                     }

                     return { style: `color: ${attributes.textColor}` };
                  },
               },
            },
         },
      ];
   },
   addStorage() {
      return {
         colors: this.options.colors,
         currentColor: null,
      };
   },
   onSelectionUpdate() {
      this.storage.currentColor =
         this.editor.getAttributes('tableHeader').textColor ||
         this.editor.getAttributes('tableCell').textColor;
   },
   addCommands() {
      return {
         setTextColor:
            (color: string) =>
            ({ commands }) => {
               if (!this.options.colors.includes(color)) {
                  return false;
               }
               this.storage.currentColor = color;
               return this.options.types.every(type =>
                  commands.updateAttributes(type, { textColor: color })
               );
            },
         unSetTextColor:
            () =>
            ({ commands }) => {
               this.storage.currentColor = null;
               return this.options.types.every(type => commands.resetAttributes(type, 'textColor'));
            },
      };
   },
});
